/**
 * The Tenant organizations CSV import columns (L-11; plans/L-11.md; ADR-75).
 *
 * The headers are the org create form's own labels, and every rule is
 * `tenantOrgCreateSchema`'s own: the import adds no second validator (docs/18
 * §4, invariant 2). Confirmed by Matt, 2026-10-12.
 *
 * WHAT IS DELIBERATELY NOT A COLUMN: Status (a lifecycle transition, refused
 * by name); addresses and phone numbers (sub-records with their own writer and
 * RLS, entered on the org's Overview after import — Matt, decision 2); tenant
 * contacts (3C.4); tenancies, leases and Yardi tenant IDs (L-12). Tenant orgs
 * carry no EIN.
 */

import type { ImportColumn } from './import-runs.ts';

export type TenantOrgImportField =
  'name' | 'industry' | 'website' | 'primaryEmail' | 'criticalInformation' | 'notes';

/** The six template columns, in template order. */
export const TENANT_ORG_IMPORT_COLUMNS: readonly ImportColumn<TenantOrgImportField>[] = [
  { header: 'Name', field: 'name', required: true, rule: '1 to 200 characters', example: '' },
  {
    header: 'Industry',
    field: 'industry',
    required: false,
    rule: 'up to 120 characters',
    example: 'Grocery',
  },
  {
    header: 'Website',
    field: 'website',
    required: false,
    rule: 'a full web address, including https://',
    example: 'https://example.com',
  },
  {
    header: 'Primary Email',
    field: 'primaryEmail',
    required: false,
    rule: 'a valid email address',
    example: 'leasing@example.com',
  },
  {
    header: 'Important Details',
    field: 'criticalInformation',
    required: false,
    rule: 'up to 4,000 characters',
    example: '',
  },
  { header: 'Notes', field: 'notes', required: false, rule: 'up to 4,000 characters', example: '' },
];
